import { createThemeDialogColorsSchema } from '../kinds/dialog/theme';
import {
  createPollThemeFontsSchema,
  createPollThemeLogotypeSchema,
  createPollThemeOthersSchema,
  createThemePollColorsSchema,
} from '../kinds/poll/theme';
import { createThemeWebviewColorsSchema, createThemeWebviewOthersSchema } from '../kinds/webview/theme';

const THEME_SCHEMAS = {
  poll: {
    colors: createThemePollColorsSchema(),
    fonts: createPollThemeFontsSchema(),
    others: createPollThemeOthersSchema(),
    logotype: createPollThemeLogotypeSchema(),
  },
  dialog: {
    colors: createThemeDialogColorsSchema(),
  },
  webview: {
    colors: createThemeWebviewColorsSchema(),
    others: createThemeWebviewOthersSchema(),
  },
};

const createThemeSection = (additionalProps: Record<string, unknown>, requiredProps: string[] = []) => ({
  type: 'object',
  properties: {
    forceColorScheme: {
      type: 'string',
      description:
        "Этот параметр определяет, какую цветовую схему следует принудительно применять в приложении. Если задано значение 'dark', будет использована тёмная тема. Если задано значение 'light' будет применена светлая тема. Если параметр не задан или его значение не указано, будет использоваться цветовая схема по умолчанию",
      enum: ['dark', 'light'],
    },
    ...additionalProps,
  },
  additionalProperties: false,
  required: ['colors', ...requiredProps],
});

const themeData = {
  type: 'object',
  properties: {
    poll: createThemeSection(
      {
        colors: THEME_SCHEMAS.poll.colors,
        fonts: THEME_SCHEMAS.poll.fonts,
        others: THEME_SCHEMAS.poll.others,
        logotype: THEME_SCHEMAS.poll.logotype,
      },
      ['fonts', 'others'],
    ),
    webview: createThemeSection(
      {
        colors: THEME_SCHEMAS.webview.colors,
        fonts: {},
        others: THEME_SCHEMAS.webview.others,
      },
      ['others'],
    ),
    dialog: createThemeSection({
      colors: THEME_SCHEMAS.dialog.colors,
      fonts: {},
      others: {},
    }),
  },
  required: ['poll', 'webview', 'dialog'],
};

export const createTheme = () => {
  return {
    type: 'object',
    properties: {
      id: { type: 'number' },
      isSystem: { type: 'boolean' },
      data: themeData,
    },
    required: ['id', 'data'],
  } as const;
};

/**
 * Создает схему для истинной темы опроса (createTruePollTheme) и схему для зам mocked темы опроса (createMockedPollTheme).
 *
 * Основная цель использования двух типов заключается в том, чтобы уменьшить количество возможных путей в объекте,
 * что может привести к ошибке TypeScript "excessive union".
 *
 * Тип createTruePollTheme описывает полные свойства темы, которые нам нужны в UI и для новых компонентов,
 * в то время как createMockedPollTheme представляет собой упрощенный, непрозрачный объект.
 * Это уменьшает количество путей и юнионов в схеме. Детали внутреннего содержания темы
 * в контексте старых тем не имеют значения, так как там не предусмотрена типизация.
 */

export const createMockedPollTheme = () => {
  return {
    type: 'object',
    properties: {
      id: { type: 'number' },
      isSystem: { type: ['boolean', 'null'] },
      data: {
        type: 'object',
      },
    },
    additionalProperties: false,
    required: ['id', 'data'],
  } as const;
};
